import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { modules } from '../../shared/order.module';
import { fuseAnimations } from '../../../@fuse/animations';

@Component({
  selector: 'terms',
  templateUrl: 'terms.html',
  styleUrls: ['./terms.component.css'],
  standalone: true,
  imports:[modules],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsCGUDialog implements OnInit {
  subdomain = '';
  constructor(
    public dialogRef: MatDialogRef<TermsCGUDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    console.log('Dialog data ===> ', data);
    //his.html5QrCode ;
    const { hostname } = new URL(window.location.href);
    let subdomain = hostname;
    this.subdomain = subdomain;
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
}
